import React, { Component, Fragment } from "react";
import { default as CrowdContentOrdersPendingOrdersTable } from "./components/CrowdContentOrdersPendingOrdersTable/CrowdContentOrdersPendingOrdersTable.js";
import { default as CrowdContentOrdersReadyOrdersTable } from "./components/CrowdContentOrdersReadyOrdersTable/CrowdContentOrdersReadyOrdersTable.js";
import { default as CrowdContentOrdersApprovedOrdersTable } from "./components/CrowdContentOrdersApprovedOrdersTable/CrowdContentOrdersApprovedOrdersTable.js";
import { default as CrowdContentOrdersRecentlyPublishedTable } from "./components/CrowdContentOrdersRecentlyPublishedTable/CrowdContentOrdersRecentlyPublishedTable.js";
import { default as CrowdContentOrderFilter } from "./components/CrowdContentOrderFilter/CrowdContentOrderFilter.js"

import {
  Card,
  CardBody,
  Nav,
  NavLink,
  NavItem,
  Badge,
  TabContent,
  TabPane,
} from "reactstrap";
import classNames from "classnames";

import {
  ReviewCrowdContentOrderModal,
  PublishCrowdContentOrderModal,
} from "./components/modals";

import {
  IN_QUEUE_TAB,
  DEFAULT_TAB,
  EDITED_ORDERS_TAB,
  RECENTLY_COMPLETED_ORDERS_TAB,
} from "./duck/constants";

class ProjectView extends Component {
  componentDidMount() {
    this.props.fetchCrowdContentOrders();
  }

  render() {
    let {
      isLoading,
      activeTab,
      setActiveTab,
      placedCrowdContentOrders,
      readyForReviewCrowdContentOrders,
      needsPostingContentOrders,
      recentlyPublishedOrders,
    } = this.props;
    return (
      <Fragment>
        {isLoading ? (
          <Fragment />
        ) : (
          <div className="row">
            <div className="col-md-12 p-2">
              <Card>
                <CardBody>
                  <Nav className="mb-1" tabs>
                    <NavItem>
                      <NavLink
                        className={classNames({
                          active: activeTab === IN_QUEUE_TAB,
                        })}
                        onClick={() => setActiveTab(IN_QUEUE_TAB)}
                      >
                        <span className="mr-2">Pending Orders</span>
                        <Badge color="secondary">
                          {placedCrowdContentOrders.length}
                        </Badge>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classNames({
                          active: activeTab === DEFAULT_TAB,
                        })}
                        onClick={() => setActiveTab(DEFAULT_TAB)}
                      >
                        <span className="mr-2">Ready for Editing</span>
                        <Badge color="secondary">
                          {readyForReviewCrowdContentOrders.length}
                        </Badge>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classNames({
                          active: activeTab === EDITED_ORDERS_TAB,
                        })}
                        onClick={() => setActiveTab(EDITED_ORDERS_TAB)}
                      >
                        <span className="mr-2">Needs Posting</span>
                        <Badge color="secondary">
                          {needsPostingContentOrders.length}
                        </Badge>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classNames({
                          active: activeTab === RECENTLY_COMPLETED_ORDERS_TAB,
                        })}
                        onClick={() =>
                          setActiveTab(RECENTLY_COMPLETED_ORDERS_TAB)
                        }
                      >
                        <span className="mr-2">Recently Published</span>
                        <Badge color="secondary">
                          {recentlyPublishedOrders.length}
                        </Badge>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <CrowdContentOrderFilter />
                    </NavItem>
                  </Nav>
                  <TabContent activeTab={activeTab}>
                    <TabPane tabId={IN_QUEUE_TAB}>
                      <CrowdContentOrdersPendingOrdersTable />
                    </TabPane>
                    <TabPane tabId={DEFAULT_TAB}>
                      <CrowdContentOrdersReadyOrdersTable />
                    </TabPane>
                    <TabPane tabId={EDITED_ORDERS_TAB}>
                      <CrowdContentOrdersApprovedOrdersTable />
                    </TabPane>
                    <TabPane tabId={RECENTLY_COMPLETED_ORDERS_TAB}>
                      <CrowdContentOrdersRecentlyPublishedTable />
                    </TabPane>
                  </TabContent>
                </CardBody>
              </Card>
            </div>
            <ReviewCrowdContentOrderModal />
            <PublishCrowdContentOrderModal />
          </div>
        )}
      </Fragment>
    );
  }
}

export default ProjectView;
